import React from "react";
import { FileManagement } from "../Files";
import config from "@poseidon/utils/config";
import DealerAction from "./DealerAction";
import { isApplicationEditable } from "../Applications/isApplicationEditable";

export function FileManagementDealer({ fileCategory, fileGroup, application }) {
  const readonly = !isApplicationEditable(application, true);
  return (
    <>
      <FileManagement
        fileCategory={fileCategory}
        resolveMetadata={config.getFileResolver(fileGroup)}
        applicationId={application.id}
        readonly={readonly}
        showMetadata={true}
      />
      {!Object.keys(config.fileDisplay.boat).includes(fileGroup) && (
        <DealerAction
          entity={config.SaltCollection.Application}
          entityKey={fileGroup}
          entityId={application.id}
          filesUploaded={null}
        />
      )}
    </>
  );
}
